/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import { IMetadata, IMetadataComponent } from '../../store/types/MetadataTypes';
import { ILevelsLayout } from '../../store/types/StateTypes';

function getCommonChartUIComponent(metadataObj: IMetadata, levelsLayout: ILevelsLayout) {
    let res: IMetadataComponent | undefined;
    if (metadataObj.component) {
        res = metadataObj.component.components.find((comp) => (comp.componentType === 'chart'));
    }

    if (!res) {
        // TODO actual default component
        res = {
            componentType: 'chart',
            components: [],
            properties: {
                drilldownEnabled: false
            }
        }
    } else if (res.properties && res.properties.advancedProperties) {
        // going thr the advanced properties and convert them into objects or arrays if they can be converted
        const { advancedProperties } = res.properties;
        // eslint-disable-next-line no-restricted-syntax
        for (const name of Object.keys(advancedProperties)) {
            try {
                advancedProperties[name] = JSON.parse(advancedProperties[name]);
            // eslint-disable-next-line no-empty
            } catch (ignore) {}
        }
    }

    return res;
}

export { getCommonChartUIComponent }
